export default __webpack_public_path__ + "static/media/delete.1d0c39c0.svg";